import React, { useEffect }  from 'react';
import {Provider} from 'mobx-react';
import {toast, alert, confirm} from 'amis';
import axios from 'axios';
import { createDirectus, staticToken, rest } from '@directus/sdk';
import {MainStore} from './store/index';
import RootRoute from './route/index';
import copy from 'copy-to-clipboard';
import { DocumentWrapper } from './component/DocumentWrapper';
// import 'amis-ui/lib/locale/en-US';
import './tailwind.css'; // 添加这一行引入 Tailwind 样式

/**
 * 创建 Directus API 客户端实例
 */
function createDirectusApi() {
  let baseUrl = window.location.origin + '/editor';
  // 开发测试
  if(process.env.NODE_ENV === 'development'){
     baseUrl = 'http://192.168.2.58:30030';
  // baseUrl = process.env.AGIMX_CORE_API_URL || '192.168.2.53:10516';
  }
 
  console.log('[DirectusAPI] 初始化，使用的 API URL:', baseUrl,(window as any).AGIMX_CONFIG);
  
  const accessToken = (window as any).AGIMX_CONFIG.CORE_TOKEN;
  
  try {
    // 确保 URL 格式正确
    const apiUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    
    // 创建 Directus 客户端
    const directusClient = createDirectus(apiUrl)
      .with(staticToken(accessToken))
      .with(rest());

    console.log(`[DirectusAPI] 已连接到: ${apiUrl}`);

    return {
      url: apiUrl,
      token: accessToken,
      client: directusClient,
      // 提供统一的请求方法
      request: (operation: any) => directusClient.request(operation)
    };
  } catch (error) {
    console.error('[DirectusAPI] 初始化失败:', error);
    throw error;
  }
}

function initUrl() {
  const baseUrl = window.location.origin;
  localStorage.setItem("baseUrl", baseUrl + "/core"); // 存入 localStorage
  localStorage.setItem("baseUrl_mind", baseUrl + "/mind");
  localStorage.setItem("baseUrl_ui", baseUrl+ "/ui");
  localStorage.setItem("baseUrl_pad", baseUrl + "/pad");
  localStorage.setItem("baseUrl_whiteboard", baseUrl + "/whiteboard");
}

export default function (): JSX.Element {
  const mode = (window as any).AGIMX_CONFIG.MODE || 'editor';
  const store = ((window as any).store = MainStore.create(
    {},
    {
      fetcher: ({url, method, data, config, headers}: any) => {
        const locales = (window as any).AGIMX_CONFIG.locales || 'zh-CN';
        const loginRoute = (window as any).AGIMX_CONFIG.lOGIN_ROUTE;
        // const baseUrl = mode === 'editor' ? 'http://192.168.2.58:30030' : window.location.origin + '/editor';
        const baseUrl = window.location.origin + '/editor';
        config = config || {};
        config.headers = config.headers || headers || {};
        config.withCredentials = true;

        // 全局处理401、403和404错误
        const _handleError = async(error: any) => { 
          const { status, data, config } = error.response;
          const statusText = data?.errors?.[0]?.message || error.response.statusText;
          if (status === 400 || status === 401 || status === 403 || status === 404 || status === 500) {
            toast.error(statusText);
          }
          if (status === 403) {
            // 请求/auth/refresh接口时，处理无权限登录
            await axios.post(baseUrl + '/auth/refresh',{mode: "session"}).catch(() => {
              toast.error(locales === 'en-US' ? 'Login expired, please log in again' : '登录已过期，请重新登录');
              // 重定向到登录页
              if (loginRoute) {
                window.location.href = loginRoute;
                return;
              }
            });
          }
          // else if (status === 400 && config.url?.includes('/auth/refresh')) {
          //   // 处理无权限登录
          //   toast.error(locales === 'en-US' ? 'Login expired, please log in again' : '登录已过期，请重新登录');
          //   // 重定向到登录页
          //   if (loginRoute) {
          //     window.location.href = loginRoute;
          //   }
          // } 
          // if (status === 401) {
          //   // 处理无权限登录
          //   toast.error(locales === 'en-US' ? 'Login expired, please log in again' : '登录已过期，请重新登录');
          //   // 重定向到登录页
          //   if (loginRoute) {
          //     window.location.href = loginRoute;
          //   }
          // } else if (status === 403) {
          //   // 处理未授权访问
          //   toast.error(locales === 'en-US' ? 'Unauthorized access' : '无权限访问');
          // } else if (status === 404) {
          //   // 处理未找到资源
          //   toast.error(locales === 'en-US' ? 'Requested resource not found' : '请求的资源不存在');
          // }
        };

        if (method !== 'post' && method !== 'put' && method !== 'patch') {
          if (data) {
            config.params = data;
          }
          
          // return (axios as any)[method](url, config);
          const request = (axios as any)[method](url, config);
          // 添加错误处理，但不改变返回的Promise结构
          request.catch((error: any) => {
            console.log("进这1",error.response);
            
            if (error.response && mode === 'view') {
              _handleError(error);
            }
          });
          
          return request;
        } else if (data && data instanceof FormData) {
          // config.headers = config.headers || {};
          // config.headers['Content-Type'] = 'multipart/form-data';
        } else if (
          data &&
          typeof data !== 'string' &&
          !(data instanceof Blob) &&
          !(data instanceof ArrayBuffer)
        ) {
          console.log("进这3");
          data = JSON.stringify(data);
          config.headers['Content-Type'] = 'application/json';
        }
        
        // return (axios as any)[method](url, data, config);
        const request = (axios as any)[method](url, data, config);
        // 添加错误处理，但不改变返回的Promise结构
        request.catch((error: any) => {
          console.log("进这5",error.response);
          
          // 全局处理401、403和404错误
          if (error.response && mode === 'view') {
            _handleError(error);
          }
          // 重新抛出错误，确保调用方可以访问错误信息
          throw error;
        });
        
        return request;
      },
      isCancel: (e: any) => axios.isCancel(e),
      notify: (type: 'success' | 'error' | 'info', msg: string) => {
        // 检查是否包含已处理的错误标记
        const errorMatch = msg.match(/status code (\d+)/);
        if (errorMatch) {
          const statusCode = parseInt(errorMatch[1]);
          if ([400, 401, 403, 404,500].includes(statusCode)) {
            // 这些错误已经在fetcher中处理过了，不需要再显示默认提示
            return;
          }
        }
        toast[type]
          ? toast[type](msg, type === 'error' ? '系统错误' : '系统消息')
          : console.warn('[Notify]', type, msg);
        console.log('[notify]', type, msg);
      },
      alert,
      confirm,
      copy: (contents: string, options: any = {}) => {
        const ret = copy(contents, options);
        ret &&
          (!options || options.shutup !== true) &&
          toast.info('内容已拷贝到剪切板');
        return ret;
      },
      // 新增：Directus API 配置
      directusApi: createDirectusApi(),
      AGIMX_APP_MODE: mode, // editor | view
    }
  ));

  // 根据环境添加CSS类名到根元素
  useEffect(() => {
    initUrl();
    const rootElement = document.getElementById('root');
    const isProduction = (window as any).AGIMX_CONFIG?.MODE === 'view';
    const locales = (window as any).AGIMX_CONFIG?.locales || 'zh-CN';
    
    if (rootElement) {
      if (isProduction) {
        rootElement.classList.add('prod-env');
      }
    }
    
    // 清理函数
    return () => {
      if (rootElement) {
        rootElement.classList.remove('prod-env');
      }
    };
  }, []);

  return (
    <Provider store={store}>
      {/* 选中文字添加到文档 */}
      <DocumentWrapper store={store}>
        <RootRoute store={store} />
      </DocumentWrapper>
    </Provider>
  );
}
